import { useMemo } from 'react';
import { createLicenseSx } from '../styles/licenseLayout';
import useLicenseTheme from './useLicenseTheme';

export default function useLicenseSx() {
  const themeTokens = useLicenseTheme();

  return useMemo(
    () => createLicenseSx({ accent: themeTokens.accent, shadows: themeTokens.shadows }),
    [themeTokens.accent, themeTokens.shadows]
  );
}
